<template>
  <div class="sticky">
    <div :class="{fixed: fixed, source: true}">
      <slot></slot>
    </div>
    <div class="sizer"></div>
  </div>
</template>

<script>
  export default {
    name: 'sticky',
    data () {
      return {
        fixed: false
      }
    },
    methods: {
      onScroll () {
        this.fixed = document.body.scrollTop > this.$el.offsetTop
      },
      checkSize () {
        const sizer = this.$el.getElementsByClassName('sizer')[0]
        const source = this.$el.getElementsByClassName('source')[0]
        if (source && sizer) {
          sizer.style.height = source.offsetHeight + 'px'
        }
      }
    },
    mounted () {
      if (document.body.onscroll) {
        const old = document.body.onscroll
        const new_ = this.onScroll
        document.body.onscroll = function (e) {
          old(e)
          new_(e)
        }
      } else {
        document.body.onscroll = this.onScroll
      }
      this.checkSize()
      this.resizeCheck = setInterval(this.checkSize, 500)
    },
    beforeDestroy () {
      clearInterval(this.resizeCheck)
    }
  }
</script>

<style lang="scss" scoped>
  .sticky {
    position: relative;
    .source {
      width: 100%;
      z-index: 2;
      position: absolute;

      &.fixed {
        top: 0;
        position: fixed;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Sticky.vue?5a2f8bbc